<template>
<div>

        
        <el-tabs v-model="active" @tab-click="handleClick">
          <el-tab-pane label="系统" name="system"></el-tab-pane>
          <el-tab-pane label="基础" name="basic"></el-tab-pane>
        </el-tabs>

        <div  v-for="(item,index) in content" :key="index" style="margin-bottom: 10px;">
            <el-input style="float: left;width: 400px;" label="原始" v-model="item.key" :disabled="true"> </el-input>
            <div style="float: left; width: 30px;height: 20px;" ></div>
            <el-input style="float: left;width: 300px;"  label="中文" v-model="item.val1"> </el-input>
            <div style="float: left;width: 30px;height: 20px;" ></div>
            <el-input style="float: left;width: 300px;"  label="英文" v-model="item.val2"> </el-input>
            <div style="clear: both;"></div>
          </div> 


    <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" >提交</el-button>
      </div>   

</div>
</template>


<script>
import Upload from '@/components/file/import'
import clip from '@/utils/clipboard'
import LangApi from '@/api/lang.js'
import { Loading } from 'element-ui';
export default {
  components:{
    Upload
  },
  data() {
    return {
      loading:true,
      /*切换菜单*/
      active:"system",
      activeName: 'zh-cn',
      content:{},
  
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData(){
      let self = this
      var loadingInstance = Loading.service({ fullscreen: true });
      LangApi.getData({
        active:self.active,
        activeName:self.activeName
      }, true).then(res => {
          self.content = res.data
          self.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
      }).catch(error => {
        console.log(error)
      })
    },
    handleClick(e){
      self.loading = true;
      this.getData();
    },
    onSubmit(){
      let self = this
      LangApi.submit({
        content:JSON.stringify(self.content),
        active:self.active,
      }, true).then(res => {
          if(res.code == 1){
            self.$message({
          message: '修改成功',
          type: 'success',
        })
          }
      }).catch(error => {
        console.log(error)
      })
    },
  }
};
</script>
<style lang="scss" scoped>
.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}
.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}
.order-code .state-text-red{ background: red;}
.table-wrap .product-info:first-of-type {
  border-top: none;
}
.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/lang/index.vue